<template>
	<div data-tour-scope="setting-ai-social">
		<v-main>
			<v-container fluid fill-height>
				<v-layout v-resize="onResize" justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> Ai / Social</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer />
						</v-toolbar>


						<v-data-table
							:headers="headers"
							class="elevation-0 cellanowrap"
							:hide-default-header="isMobile || mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							hide-default-footer
							disable-pagination
							disable-sort
							item-key="item._id"
							data-tour="table"
						>
							<template #body>
								<!-- telefono: ogni servizio diventa una card con logo, attivazione e impostazioni -->
								<tbody v-if="mobileCards" class="aisocial-cards">
									<tr v-for="s in servizi" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<div class="d-flex align-center">
														<v-avatar size="32px" tile class="mr-2">
															<img :src="s.logo" :alt="s.nome" />
														</v-avatar>
														{{ s.nome }}
													</div>
												</template>
												<template v-slot:actions>
													<v-switch v-model="modello(s).active" color="primary" class="mt-0 pt-0 mr-2" hide-details @change="saveSetting(s.indice)" />
													<v-btn small icon color="primary" :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click="extension(s.indice)">
														<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<service-panel
													v-if="checkpresenza(s.indice)"
													:servizio="s"
													:modello="modello(s)"
													:intestazione="false"
													:data-tour="s.indice === 0 ? 'settings' : null"
													@save="saveSetting(s.indice)"
												>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="s in servizi">
										<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(s.indice) }" @click="extension(s.indice)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click.stop="extension(s.indice)">
													<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="s.logo" :alt="s.nome" />
												</v-avatar>
												{{ s.nome }}
											</td>
											<td @click.stop>
												<v-switch v-model="modello(s).active" color="primary" class="mt-0" hide-details @change="saveSetting(s.indice)" />
											</td>
										</tr>
										<tr v-if="checkpresenza(s.indice)" :key="s.key + '-panel'" class="as-expanded">
											<td :colspan="headers.length" class="py-3">
												<service-panel :servizio="s" :modello="modello(s)" :data-tour="s.indice === 0 ? 'settings' : null" @save="saveSetting(s.indice)">
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service" :draft="connectionDraft"></marketplace-connection-check>
	</div>
</template>

<script>
import Vue from 'vue';

import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ServicePanel from './components/ServicePanel.vue';
import MarketplaceConnectionCheck from './components/MarketplaceConnectionCheck.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createAiSocialTourSteps, stopAiSocialTour } from './ai-social-tour';
import { VueMaskDirective } from 'v-mask';

Vue.directive('mask', VueMaskDirective);

export default {
	name: 'Framework',
	setup() {
		return { tour: useTour(createAiSocialTourSteps(), { onStop: stopAiSocialTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},
	components: {
		TourOverlay,
		KeyValueCard,
		ServicePanel,
		MarketplaceConnectionCheck,
	},
	data() {
		return {
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// riquadri di configurazione aperti (indice del servizio)
			selected: [],
			// verifica connessione: verifica i dati del form, anche se non ancora salvati
			connectionCheck: { open: false, service: 'openai' },
			headers: [{ text: '', sortable: false }, { text: 'AI / social', sortable: false }, { text: 'Status', sortable: false }],
			messages: {
				email: [],
				name: [],
				password: [],
			},

			isMobile: false,

			openai: {
				active: false,
				setting: {
					key: '',
					text: '',
					image: '',
					voice: '',
				},
				type: 'ai',
				service: 'openai',
			},
			facebook: {
				active: false,
				setting: {
					app_id: '',
					app_secret: '',
					user_id: '',
					page_id: '',
					token: '',
					expired: '',
				},
				type: 'social',
				service: 'facebook',
			},
			instagram: {
				active: false,
				setting: {
					app_id: '',
					app_secret: '',
					user_id: '',
					page_id: '',
					token: '',
					expired: '',
				},
				type: 'social',
				service: 'instagram',
			},
			aiassistent: {
				active: false,
				setting: {
					rule: '',
					ai: '',
					autoPrompt: false,
					autoPromptDelay: 5,
				},
				type: 'ai',
				service: 'aiassistent',
			},
			tiktok: {
				active: false,
				setting: {},
				type: 'social',
				service: 'tiktok',
			},

			lists: [],

			// righe della tabella: indice = argomento di saveSetting/extension, key = oggetto in data
			servizi: [
				{
					indice: 0,
					key: 'openai',
					connessione: 'openai',
					nome: 'Openai',
					logo: require('@/assets/images/ai/openai.svg'),
					campi: [
						{ key: 'key', label: 'Key', pieno: true },
						{ key: 'text', label: 'Modello testo', tipo: 'combobox', items: ['gpt-4.1', 'gpt-4.1-mini', 'gpt-4.1-nano', 'gpt-4o', 'gpt-4o-mini', 'gpt-5', 'gpt-5-mini'] },
						// solo modelli che restituiscono un url: gpt-image-1 risponde in base64 e image() non lo gestisce
						{ key: 'image', label: 'Modello immagini', tipo: 'combobox', items: ['dall-e-3', 'dall-e-2'] },
						{ key: 'voice', label: 'Modello voce (speech-to-text)', tipo: 'select', clearable: true, items: ['gpt-4o-mini-transcribe', 'gpt-4o-transcribe', 'whisper-1'] },
					],
				},
				{
					indice: 1,
					key: 'facebook',
					connessione: 'facebook',
					nome: 'Facebook',
					logo: require('@/assets/images/social/facebook.svg'),
					campi: [
						{ key: 'app_id', label: 'App ID' },
						{ key: 'app_secret', label: 'App Secret' },
						{ key: 'user_id', label: 'User ID' },
						{ key: 'page_id', label: 'Page ID' },
						{ key: 'token', label: 'Token long lived', tipo: 'textarea', pieno: true },
						{ key: 'expired', label: 'Data scadenza GG/MM/YYYYY', mask: '##/##/####' },
					],
				},
				{
					indice: 2,
					key: 'instagram',
					connessione: 'instagram',
					nome: 'Instagram',
					logo: require('@/assets/images/social/instagram.svg'),
					campi: [
						{ key: 'app_id', label: 'App ID' },
						{ key: 'app_secret', label: 'App Secret' },
						{ key: 'user_id', label: 'User ID' },
						{ key: 'page_id', label: 'Instagram Business Account' },
						{ key: 'token', label: 'Token long lived', tipo: 'textarea', pieno: true },
						{ key: 'expired', label: 'Data scadenza GG/MM/YYYYY', mask: '##/##/####' },
					],
				},
				{
					indice: 3,
					key: 'tiktok',
					nome: 'TikTok',
					logo: require('@/assets/images/social/tiktok.svg'),
					campi: [],
				},
				{
					indice: 4,
					key: 'aiassistent',
					connessione: 'aiassistent',
					nome: 'AI Assistent',
					logo: require('@/assets/images/ai/aiassistent.svg'),
					titoloSwitch: 'Attivazione automatica',
					campi: [
						{ key: 'ai', label: 'AI platform', tipo: 'select', items: ['opeanai'] },
						{ key: 'rule', label: 'Regole', tipo: 'textarea', pieno: true },
						// pagina prodotto del sito: dopo N secondi il chatbot propone informazioni sul prodotto
						{ key: 'autoPrompt', label: 'Vuoi che si attivi in automatico?', tipo: 'switch', numero: { key: 'autoPromptDelay', label: 'Dopo quanti secondi' } },
					],
				},
			],
		};
	},

	async created() {
		this.setPreload(true);
		let promises = [];
		this.lists = ['openai', 'facebook', 'instagram', 'tiktok', 'aiassistent'];
		promises.push(this.fetchSettings());
		promises.push(this.fetchService(this.lists));
		await Promise.all(promises);

		this.setPreload(false);

		let openai = _.find(this.getServices, set => {
			return set.service === 'openai';
		});
		if (openai) {
			this.openai = {
				active: openai.active,
				setting: {
					key: openai.setting?.key ? openai.setting.key : '',
					text: openai.setting?.text ? openai.setting.text : '',
					image: openai.setting?.image ? openai.setting.image : '',
					voice: openai.setting?.voice ? openai.setting.voice : '',
				},
				type: 'ai',
				service: 'openai',
			};
		}

		let facebook = _.find(this.getServices, set => {
			return set.service === 'facebook';
		});
		if (facebook) {
			this.facebook = {
				active: facebook.active,
				setting: {
					app_id: facebook.setting?.app_id ? facebook.setting.app_id : '',
					app_secret: facebook.setting?.app_secret ? facebook.setting.app_secret : '',
					user_id: facebook.setting?.user_id ? facebook.setting.user_id : '',
					page_id: facebook.setting?.page_id ? facebook.setting.page_id : '',
					token: facebook.setting?.token ? facebook.setting.token : '',
					expired: facebook.setting?.expired ? facebook.setting.expired : '',
				},
				type: 'social',
				service: 'facebook',
			};
		}

		let instagram = _.find(this.getServices, set => {
			return set.service === 'instagram';
		});
		if (instagram) {
			this.instagram = {
				active: instagram.active,
				setting: {
					app_id: instagram.setting?.app_id ? instagram.setting.app_id : '',
					app_secret: instagram.setting?.app_secret ? instagram.setting.app_secret : '',
					user_id: instagram.setting?.user_id ? instagram.setting.user_id : '',
					page_id: instagram.setting?.page_id ? instagram.setting.page_id : '',
					token: instagram.setting?.token ? instagram.setting.token : '',
					expired: instagram.setting?.expired ? instagram.setting.expired : '',
				},
				type: 'social',
				service: 'instagram',
			};
		}

		let aiassistent = _.find(this.getServices, set => {
			return set.service === 'aiassistent';
		});
		if (aiassistent) {
			this.aiassistent = {
				active: aiassistent.active,
				setting: {
					rule: aiassistent.setting?.rule ? aiassistent.setting.rule : '',
					ai: aiassistent.setting?.ai ? aiassistent.setting.ai : '',
					autoPrompt: !!aiassistent.setting?.autoPrompt,
					autoPromptDelay: aiassistent.setting?.autoPromptDelay ? aiassistent.setting.autoPromptDelay : 5,
				},
				type: 'ai',
				service: 'aiassistent',
			};
		}

		let tiktok = _.find(this.getServices, set => {
			return set.service === 'tiktok';
		});
		if (tiktok) {
			this.tiktok = {
				active: tiktok.active,
				setting: {},
				type: 'social',
				service: 'tiktok',
			};
		}
	},
	computed: {
		// dati del form del servizio da verificare: la verifica non aspetta il salvataggio
		connectionDraft() {
			const servizio = this.servizi.find(s => s.connessione === this.connectionCheck.service);
			const modello = servizio && this[servizio.key];
			return modello ? { setting: modello.setting, active: !!modello.active } : null;
		},
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',

			getServices: 'services/getServices',
		}),
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
		}),

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		async saveSetting(item) {
			let payload;

			switch (item) {
				case 0:
					payload = this.openai;
					this.setPreload(true);
					break;
				case 1:
					payload = this.facebook;
					this.setPreload(true);
					break;
				case 2:
					payload = this.instagram;
					this.setPreload(true);
					break;
				case 3:
					payload = this.tiktok;
					this.setPreload(true);
					break;
				case 4:
					payload = this.aiassistent;
					this.setPreload(true);
					break;
			}
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, {
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(({ data }) => {
					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		extension(item) {
			let check = this.selected.includes(item);
			if (!check) {
				this.selected.push(item);
			} else {
				let index = this.selected.indexOf(item);
				this.selected.splice(index, 1);
			}
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		// oggetto in data del servizio (openai, facebook, ...): created() lo sostituisce, quindi va letto ogni volta
		modello(servizio) {
			return this[servizio.key];
		},
	},
};
</script>

<style></style>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.aisocial-cards,
.aisocial-cards tr {
	display: block;
	width: 100%;
}
.aisocial-cards tr,
.aisocial-cards tr:hover {
	background: transparent !important;
}
.aisocial-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.aisocial-cards tr:first-child td {
	padding-top: 12px !important;
}
.aisocial-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.aisocial-cards tr + tr td {
	padding-top: 8px !important;
}
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
